import { ClaimsProvider } from "@nmible-ltd/claims";
import { type ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { usePwaClaimsApi } from "../hooks/use-pwa-claims-api";

export const PwaClaimsProvider = ({ children }: { children: ReactNode }) => {
  const { t, i18n } = useTranslation();
  const api = usePwaClaimsApi();

  return (
    <ClaimsProvider api={api} t={t} locale={i18n.language}>
      {children}
    </ClaimsProvider>
  );
};
